<template>
  <div class="hello">

    <menupicker value="aboutus">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>
    <div class="center green rcorners1">
      <p>{{ content }}</p>
      <img class="photos" v-for="p in photos " :src="'https://gmbch.org/aboutphotos/'+p"/>
      <video class="photos" v-for="v in videos " :src="'https://gmbch.org/aboutphotos/'+v" controls/>
    </div>
    <div>
      <p> See us on Facebook!</p>
        <a href="http://www.facebook.com/pages/Grand-Mesa-Back-Country-HorsemenGMBCH/146923545363819" target="_blank">
          <img src="../assets/FB-f-Logo__blue_57.png"/>
      </a>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from 'aws-sdk/clients/dynamodb';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

export default {
  name: 'AboutUs',
  data () {
    return {
      active: 'aboutus',
      msg: 'About Us',
      content: '',
      photos: [],
      videos: [],
      president: 'Yancy Melancon',
      phnumber: '337-344-8313',
      address1: 'PO Box 4872',
      address2: '',
      city: 'Grand Junction',
      state: 'Colorado',
      zip: '81502',
      email: 'brushhog@ymail.com',
      emaillink: 'mailto::brushhog@ymail.com'
    }
  },
  methods: {
    loadS3Images(awscredentials) {
      const s3 = new AWS.S3({
        region: localStorage.getItem('region'),
        credentials: awscredentials,
      });

      var params = {
        Bucket: "gmbch-about-photos",
        MaxKeys: 20
      };

      return new Promise((resolve, reject) => {
        s3.listObjectsV2(params, function (err, data) {
          if (err) {
            console.error(err, err.stack);
            reject(`s3 error ${error.message}`);
          }
          resolve(data);
        });
      })
    },
    loadData(awscredentials) {
      const docClient = new DynamoDb.DocumentClient({
        region: localStorage.getItem('region'),
        credentials: awscredentials,
      });

      const query = {
        TableName: 'about-webcontents',
        KeyConditions: {
          pageid: {
            ComparisonOperator: 'EQ',
            AttributeValueList: ['about']
          }
        }
      }
      return new Promise((resolve, reject) => {
        docClient.query(
          query,
          (error, data) => {
            if (error) {
              console.error('dynamodb error: ' + error.message);
              reject(`dynamodb error: ${error.message}`);
            }
            resolve(data);
          }
        )
      })
    },
    parseData(data){
      console.log(JSON.stringify(data.Items[0].content, null, 2));
      this.content = data.Items[0].content;
    },
    parseS3Data(data) {
      console.log(JSON.stringify(data, null, 2));
      this.photos = [];
      this.videos = [];
      for (let i = 0; i < data.Contents.length; i++) {
        if (data.Contents[i].Key.endsWith('mp4')) {
          this.videos[this.videos.length] = data.Contents[i].Key;
        } else {
          this.photos[this.photos.length] = data.Contents[i].Key;
        }
      }
    },
    initCredentials() {
      const credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: localStorage.getItem('poolid'),
      }, { region: localStorage.getItem('region')});
      return credentials;
    }
  },
  mounted() {
    const creds = this.initCredentials();
    this.loadData(creds)
      .then(data => this.parseData(data));
    this.loadS3Images(creds)
      .then(data => this.parseS3Data(data));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  h1 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 100%;
    text-align: left;
  }

  .center {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    margin: auto;
    margin-top: 5px;
    width: 95%;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

  .photos {
    height: 300px;
    margin: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue